module.exports = __webpack_public_path__ + "static/pic01-e3afa47ce1269848537af2ab5b348fad.jpg";